"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMedguides = void 0;
var axios_1 = require("axios");
function getMedguides(medguidesKey, ndcNumber, languageCode) {
    return axios_1.default.get("https://dha.health-ce.wolterskluwer.com/v1/medications/ndc/".concat(ndcNumber, "/article.json?lang=").concat(languageCode, "&useGeneralArticle=true&fields=links.contentShortUrl"), {
        headers: {
            "subscription-key": medguidesKey,
        },
    });
}
exports.getMedguides = getMedguides;
